import React from "react";

import {DataCard} from "./cards/Card";
import {properties} from "../../properties";

export function TitleBlock({title}) {
	const color = properties.kbrColors.pantone301Blue;

	return (
		<DataCard
			className="text-center"
			style={{backgroundColor: properties.kbrColors.lightBlue, color: color, borderColor: color}}>
			<h4>
				<b>{title}</b>
			</h4>
		</DataCard>
	);
}
